/* eslint-disable max-len */
import { memo } from 'react';

interface IRightArrowBoldProps {
  color: string
}

function RightArrowBold({ color }: IRightArrowBoldProps) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 9.00049H18M11 2.00049L18 9.00049L11 16.0005"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(RightArrowBold);
